import allCountries from './countries.json';

const alpha3CountryCodeToAlpha2CountryCode = (alpha3: string) => {
    return allCountries.flat().find((country) => country.id === alpha3)?.cca2;
};

export default alpha3CountryCodeToAlpha2CountryCode;
